export const NUMBER_OF_ALL_PARCELS = 25;
export const DISPLAY_BOMB_TIME = 1500;
export const TOTAL_ROUNDS_NUMBER = 5;
export const MAIN_TRAILS_NUMBER = 4;
export const HIDE_PARCEL_INTERVAL_TIME = 1000;
